module.exports = __webpack_public_path__ + "img/edit.4731edbc.svg";